import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { find } from 'lodash';

const initialState = {
  organizations: [],
  currentPage: 1,
  totalPages: 1,
  totalCount: 0,
  loading: false,
  isOrganizationCreated: false,
  isOrganizationEdited: false,
  selectedOrganization: {},
  is_embedded: false,
  error: null,
};

const organizationSlice = createSlice({
  name: 'organizations',
  initialState,
  reducers: {
    fetchOrganizationsRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchOrganizationsSuccess(state, action) {
      state.loading = false;
      state.organizations = action.payload.organizations;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalCount = action.payload.totalCount;
    },
    fetchOrganizationsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    fetchOrganizationById(state) {
      state.loading = true;
      state.error = null;
    },
    fetchOrganizationByIdSuccess(state, action) {
      const organization = action.payload.organization;
      let found = find(state.organizations, { _id: organization._id });
      if (!found) {
        state.organizations.push(organization);
      }
      state.loading = false;
      state.selectedOrganization = action.payload.organization;
      state.is_embedded_partner = action.payload.is_embedded;
    },
    fetchOrganizationByIdFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    createOrganizationRequest(state) {
      state.loading = true;
      state.error = null;
      state.isOrganizationCreated = false;
    },
    editOrganizationRequest(state) {
      state.loading = true;
      state.error = null;
      state.isOrganizationEdited = false;
    },
    createOrganizationSuccess(state) {
      state.loading = false;
      state.error = null;
      state.isOrganizationCreated = true;
    },
    editOrganizationFailure(state, action) {
      state.loading = false;
      state.isOrganizationEdited = false;
      state.error = action.payload;
    },
    editOrganizationSuccess(state) {
      state.loading = false;
      state.error = null;
      state.isOrganizationEdited = true;
    },
    createOrganizationFailure(state, action) {
      state.loading = false;
      state.isOrganizationCreated = false;
      state.error = action.payload;
    },
    cancelOrganizationCreate(state) {
      state.loading = false;
      state.error = null;
      state.isOrganizationCreated = false;
      state.isOrganizationEdited = false;
    },
    markOrganizationCreated(state, action) {
      state.isOrganizationCreated = action.payload;
    },
    markOrganizationEdited(state, action) {
      state.isOrganizationEdited = action.payload;
    },
  },
});

export const {
  fetchOrganizationsRequest,
  fetchOrganizationsSuccess,
  fetchOrganizationsFailure,
  fetchOrganizationById,
  fetchOrganizationByIdSuccess,
  fetchOrganizationByIdFailure,
  createOrganizationRequest,
  createOrganizationSuccess,
  createOrganizationFailure,
  editOrganizationRequest,
  editOrganizationFailure,
  editOrganizationSuccess,
  markOrganizationCreated,
  markOrganizationEdited,
  cancelOrganizationCreate,
} = organizationSlice.actions;

const organizationState = (state) => state.organizations;

export const selectOrganizationById = (id) =>
  createSelector(
    [organizationState],
    (organizationState) => organizationState.organizations.find((org) => org._id === id) || {},
  );

export default organizationSlice.reducer;
